import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { AppBar, Toolbar as MuiToolbar, Typography, IconButton, Tooltip } from '@mui/material';
import { ArrowBack, Home, Edit, EditOff, Logout } from '@mui/icons-material';
import { useEditMode } from '../context/EditModeContext';
import { useAuth } from '../context/AuthContext';

// En producción, usar URL relativa (Nginx redirige /api/ al backend)
// En desarrollo, usar localhost:5000
// Si REACT_APP_API_URL está configurado pero es HTTP, usar ruta relativa en HTTPS
let API_URL = process.env.REACT_APP_API_URL || '';
if (API_URL && API_URL.startsWith('http://') && typeof window !== 'undefined' && window.location.protocol === 'https:') {
  // Si estamos en HTTPS pero API_URL es HTTP, usar ruta relativa
  API_URL = '';
} else if (!API_URL && process.env.NODE_ENV !== 'production') {
  API_URL = 'http://localhost:5000';
}

function Toolbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { editMode, toggleEditMode } = useEditMode();
  const { logout } = useAuth();
  const [nombrePropiedad, setNombrePropiedad] = useState(null);
  const isHome = location.pathname === '/';
  
  // Extraer el ID de la URL manualmente
  const match = location.pathname.match(/\/propiedad\/(\d+)/);
  const id = match ? match[1] : null;

  useEffect(() => {
    if (id && !isHome) {
      const cargarNombrePropiedad = async () => {
        try {
          const response = await axios.get(`${API_URL}/api/propiedades`);
          const propiedad = response.data.find(p => p.id === parseInt(id));
          if (propiedad) {
            setNombrePropiedad(propiedad.nombre);
          } else {
            setNombrePropiedad(null);
          }
        } catch (error) {
          console.error('Error cargando nombre de propiedad:', error);
          setNombrePropiedad(null);
        }
      };
      
      cargarNombrePropiedad();
      // Recargar periódicamente para detectar cambios
      const interval = setInterval(() => {
        cargarNombrePropiedad();
      }, 2000);
      return () => clearInterval(interval);
    } else {
      setNombrePropiedad(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isHome]);

  return (
    <AppBar position="static" sx={{ mb: 3 }}>
      <MuiToolbar>
        {!isHome && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="volver"
            onClick={() => navigate('/')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
        )}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1, textAlign: isHome ? 'left' : 'center' }}>
          {isHome ? 'Bragantinis Project' : (nombrePropiedad || 'Cargando...')}
        </Typography>
        <Tooltip title={editMode ? "Salir del modo edición" : "Modo edición"}>
          <IconButton
            color="inherit"
            aria-label="modo edición"
            onClick={toggleEditMode}
            sx={{ mr: isHome ? 0 : 1 }}
          >
            {editMode ? <EditOff /> : <Edit />}
          </IconButton>
        </Tooltip>
        {!isHome && (
          <IconButton
            color="inherit"
            aria-label="inicio"
            onClick={() => navigate('/')}
            sx={{ mr: 1 }}
          >
            <Home />
          </IconButton>
        )}
        <Tooltip title="Cerrar sesión">
          <IconButton
            color="inherit"
            aria-label="cerrar sesión"
            onClick={() => {
              logout();
              navigate('/login');
            }}
          >
            <Logout />
          </IconButton>
        </Tooltip>
      </MuiToolbar>
    </AppBar>
  );
}

export default Toolbar;
